import HistoryIcon from './HistoryIcon'
import HomeIcon from './HomeIcon'
import LanguageIcon from './LanguageIcon'
import MenuIcon from './MenuIcon'
import SoundOffIcon from './SoundOffIcon'
import SoundOnIcon from './SoundOnIcon'
import SubtitlesOffIcon from './SubtitlesOffIcon'
import SubtitlesOnIcon from './SubtitlesOnIcon'

export {
  HistoryIcon,
  HomeIcon,
  LanguageIcon,
  MenuIcon,
  SoundOffIcon,
  SoundOnIcon,
  SubtitlesOffIcon,
  SubtitlesOnIcon
}
